import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import moment from "moment";
import { Card, Table, Tabs, Pagination, Popconfirm, message, Button, Checkbox, Input, Select } from "antd";
import { columns } from "./tableConfigs";
import Service from "../../services/blog";

const Blogs = () => {
  
  const history = useHistory();

  const TabPane = Tabs.TabPane;
  const { Search } = Input;
  const Option = Select.Option;

  const [data, setData] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [totalCount, setTotalCount] = useState(100);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [search_text, setSearch_text] = useState("");
  const [selected_levels, setSelected_levels] = useState([0]);
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredInfo, setFilteredInfo] = useState(null);
  const [sortedInfo, setSortedInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [isFeatured, setIsFeatured] = useState(false);

  useEffect(() => {
    getBlogsData();
  }, []);

  const getBlogsData = async () => {
    let response = await fetchData({
      name: search_text,
      // isActive: isActive,
      level: selected_levels,
      isFeatured: isFeatured,
      pageIndex: pageIndex,
      pageSize: pageSize,
    });

    setData(response.data);
    setTotalCount(!!response ? response.total : 100);
    setPageIndex(pageIndex + 1);
    setLoading(false);
  }

  const onEdit = (e, id) => {
    e.preventDefault();
    console.log(id);
    history.push(`/blogEditForm/${id}`);
  }

  const fetchData = async (params) => {
    setLoading(true);

    let blogs = await Service.getBlogs({
      searchTerm: params?.name || "",
      // isActive: params?.isActive ?? "all",
      pageSize: params?.pageSize || 100,
      pageIndex: params?.pageIndex || 0,
    });

    let data =
      !!blogs &&
      blogs.data?.map((item, index) => {
        return {
          key: item._id,
          id: index + 1 + pageIndex * params?.pageSize,
          title: item.title,
          slug: item.slug,
          level: Number(item.level) + 1,
          date: moment(item.updatedAt).format("YYYY-MM-DD"),
          status: item.isActive ? "Active" : "Inactive",
          action: (
            <div className="action-btn">
              <a href="" title="Edit" onClick={(e) => onEdit(e, item._id)}>
                <i className="fa fa-pencil"></i>
              </a>
              <a href="" title="Delete">
                <Popconfirm
                  title="Are you sure delete this ?"
                  onConfirm={async () => {
                    console.log(item._id);
                    let response = await Service.deleteBlog(item._id, item.isActive);

                    if (response.message === "blog.blogDeleted") {
                      message.success("Record Deleted!");

                      const LEVEL =
                        selected_levels.length !== 0 &&
                        selected_levels;

                      let response = await fetchData({
                        name: search_text,
                        level: LEVEL,
                        isActive: isActive,
                        isFeatured: isFeatured,
                        pageSize: pageSize,
                        pageIndex: pageIndex,
                      });

                      setData(response.data);
                      setTotalCount(!!response ? response.total : 0);
                      setLoading(false);
                    } else {
                      message.error("An unexpected error has occured while deleting record.");
                    }
                  }}
                  onCancel={() => { }}
                  okText="Yes"
                  cancelText="No"
                >
                  <span className="gx-link" title="Delete">
                    <i className="icon icon-trash"></i>
                  </span>
                </Popconfirm>
              </a>
            </div >
          ),
        };
      });

    return { data, total: blogs.total };
  };

  const onPageChange = async (page) => {

    setPageIndex(page - 1);
    setCurrentPage(page);
    setLoading(true);

    const LEVEL = selected_levels.length !== 0 && selected_levels;

    let result = await fetchData({
      name: search_text,
      isActive: isActive,
      level: LEVEL,
      isFeatured: isFeatured,
      pageIndex: page - 1,
      pageSize: pageSize,
    });

    setData(result.data);
    setTotalCount(!!result ? result.total : 100);
    setLoading(false);
  }

  const onSearch = () => onSearchPress();

  const onSearchChange = (e) => setSearch_text(e.target.value);

  const onClear = () => {
    setData([]);
    setIsActive("all");
    setTotalCount(100);
    setPageIndex(0);
    setPageSize(100);
    setSearch_text("");
    setSelected_levels([0]);
    setCurrentPage(1);
    setFilteredInfo(null);
    setSortedInfo(null);
    setLoading(false);
    setVisible(false);

    onSearchPress();
  }

  const onSearchPress = async () => {
    setPageIndex(0);
    setCurrentPage(1);
    setLoading(true);

    let data = await fetchData({
      name: search_text,
      isActive: isActive,
      level: selected_levels,
      isFeatured: isFeatured,
      pageIndex: 0,
      pageSize: pageSize,
    });

    setData(data.data);
    setTotalCount(!!data ? data.total : 100);
    setPageIndex(pageIndex + 1);
    setLoading(false);
  }

  const onCheckChange = (e, id) => {
    const isChecked = e.target.checked;
    let result = selected_levels,
      ID = id - 1;

    if (isChecked) {
      result.push(ID);
      result = [...new Set(result)];
    }
    if (!isChecked) {
      result = result.filter((item) => item !== ID);
    }
    result = result.length > 0 ? result : [0];
    setSelected_levels(result);
  }

  const handleSelectChange = (value) => {
    setIsActive(value === "active" ? true : value === "inactive" ? false : "all");
  }

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  // MULTIPLE-scripts start
  const children = [];
  for (let i = 1; i < 100; i++) {
    children.push(<Option key={i.toString(36) + i}>{"test"}</Option>);
  }
  // MULTIPLE-scripts End

  // Sort-Table-Scripts-Start
  let sorted = sortedInfo || {};
  let filtered = filteredInfo || {};
  // sort-table-scripts-End

  let totalCounts = totalCount
    ? Math.ceil(totalCount / 100) * 100
    : 100;

  return (
    <div className="menu-editor-box card-pad-new menu-cate-list users-main-page">
      <div className="payout-report-box">
        <Card className="gx-card breadcrumb-box" title="">
          <div className="ant-row hd-title">
            <div className="ant-col-md-12">
              <h1>Blogs</h1>
            </div>
            <div className="ant-col-md-12 rite-btn">
              <Button
                type="primary"
                className="color-white"
                onClick={() => {
                  history.push("/blogForm");
                }}
              >
                <i className="icon icon-add"></i> Add
                </Button>
            </div>

            <div className="ant-col-md-12 rite-btn d-none">
              <div className="search-box">
                <Search
                  placeholder="search"
                  value={search_text}
                  onSearch={onSearch}
                  onChange={onSearchChange}
                  style={{ width: 200 }}
                />
              </div>
              <Button type="primary" className="color-white">
                Clear
                </Button>
              <Select
                className="status-dropdown"
                defaultValue="1"
                style={{ width: 100 }}
              >
                <Option value="1">More</Option>
              </Select>
            </div>
          </div>

          <Tabs
            type="card"
            className="tabs-main-box gx-mt-4"
          >
            <TabPane tab="Default" key="1">
              <div className="ant-col-md-24 rite-btn ">
                <div className="search-box">
                  <Search
                    placeholder="search"
                    style={{ width: 200 }}
                    onSearch={onSearch}
                    onChange={onSearchChange}
                    value={search_text}
                  />
                </div>
                <Button className="my-btn-cust" onClick={onClear}>
                  Clear
                  </Button>
                <a
                  className="my-btn-link more-link d-none"
                  onClick={() => {
                    setVisible(!visible);
                  }}
                >
                  More <i className="icon icon-chevron-down"></i>
                </a>
              </div>

              {visible && (
                <div className="ant-row gx-m-0 gx-mt-3 additional-filter">
                  <div className="ant-col-md-7 gx-mb-3 gx-pl-2 gx-pr-2">
                    <Select
                      showSearch
                      defaultValue="active"
                      placeholder="Type"
                      optionFilterProp="children"
                      onChange={handleSelectChange}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      <Option value="all">All</Option>
                      <Option value="active">Active</Option>
                      <Option value="inactive">Inactive</Option>
                    </Select>
                  </div>
                  <div className="ant-col-md-3 gx-mb-3 gx-pl-2 gx-pr-2 ms-chckbx-col">
                    <Checkbox
                      defaultChecked={true}
                      onChange={(e) => onCheckChange(e, "1")}
                    >
                      Level 1
                      </Checkbox>
                  </div>
                  <div className="ant-col-md-3 gx-mb-3 gx-pl-2 gx-pr-2 ms-chckbx-col">
                    <Checkbox onChange={(e) => onCheckChange(e, "2")}>
                      Level 2
                      </Checkbox>
                  </div>
                  <div className="ant-col-md-3 gx-mb-3 gx-pl-2 gx-pr-2 ms-chckbx-col">
                    <Checkbox onChange={(e) => onCheckChange(e, "3")}>
                      Level 3
                      </Checkbox>
                  </div>
                  <div className="ant-col-md-3 gx-mb-3 gx-pl-2 gx-pr-2 ms-chckbx-col">
                    <Checkbox onChange={(e) => onCheckChange(e, "4")}>
                      Level 4
                      </Checkbox>
                  </div>
                  <div className="ant-col-md-3 gx-mb-3 gx-pl-2 gx-pr-2"></div>
                  <div className="ant-col-md-2 gx-mb-3 gx-pl-2 gx-pr-2">
                    <Button
                      onClick={onSearchPress}
                      className="my-btn-cust"
                    >
                      Search
                      </Button>
                  </div>
                </div>
              )}
              <div className="ant-row gx-mt-3 bulk-btn-option">
                <div className="ant-col-md-24 pageing-box">
                  <Pagination
                    simple
                    pageSize={100}
                    defaultCurrent={1}
                    total={totalCounts}
                    onChange={onPageChange}
                    current={currentPage}
                  />
                </div>
              </div>

              <div className="collaps-main">
                <div className="ant-row d-none">
                  <div className="search-box ant-col-md-12">
                    <Search
                      placeholder="search"
                      onSearch={(value) => console.log(value)}
                      style={{ width: 200 }}
                    />
                  </div>
                </div>

                <div className="ant-row">
                  <div className="ant-col gx-order-sm-1 ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24">
                    <Table
                      rowKey={(record) => {
                        return record?.key;
                      }}
                      pagination={{ pageSize: 100 }}
                      className="gx-table-responsive menu-cate-lisi-table sellads-table"
                      columns={columns({ sorted, filtered })}
                      loading={loading}
                      dataSource={data}
                      onChange={handleChange}
                    />
                    <div className="pageing-box gx-mt-4">
                      <Pagination
                        simple
                        pageSize={100}
                        defaultCurrent={1}
                        total={totalCounts}
                        onChange={onPageChange}
                        current={currentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </TabPane>

          </Tabs>
        </Card>
      </div>
    </div>
  );
}

export default Blogs;